import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Entite, InterneExterne} from '../../../../../models/entite/EntiteResponse';
import {MatInputModule} from '@angular/material/input';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatSelectModule} from '@angular/material/select';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {map, Observable, startWith} from 'rxjs';
import {MatDividerModule} from '@angular/material/divider';
import {
  ProfilsEntitesUtilisateurBody
} from '../../../../../models/profilsEntitesUtilisateur/ProfilsEntitesUtilisateurBody';
import {ProfilService} from '../../../../../services/profil/profil.service';
import {Profil} from '../../../../../models/profil/Profil';

@Component({
  selector: 'app-ajouter-profil-dialogue',
  standalone: true,
  imports: [MatInputModule, ReactiveFormsModule, MatSelectModule, MatButtonModule, CommonModule, MatAutocompleteModule, MatDividerModule],
  templateUrl: './ajouter-modifier-profil-dialogue.component.html',
  styleUrl: './ajouter-modifier-profil-dialogue.component.scss'
})
export class AjouterModifierProfilDialogueComponent implements OnInit {
  profilForm: FormGroup;
  entites: Entite[];
  filteredEntites: Observable<Entite[]>;
  profilsOptions: Observable<Profil[]> | undefined;
  isEditMode = this.data.editMode;

  constructor(
    private profilService: ProfilService,
    public dialogRef: MatDialogRef<AjouterModifierProfilDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.entites = data.entites;
    this.profilForm = new FormGroup({
      entite: new FormControl(this.data.entiteSelectionnee, Validators.required),
      profils: new FormControl(this.data.profilIds) 
    });

    this.filteredEntites = this.profilForm.get('entite')!.valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value : value.libelle),
      map(libelle => libelle ? this.filterEntities(libelle) : this.entites.slice())
    );
  }

  ngOnInit(): void {
    this.loadProfilOptions();
  }

  loadProfilOptions(): void {
    this.profilsOptions = this.profilService.getProfils({ id_application: 2 }).pipe(
      map(response => {  
        const filteredData = response.data.filter((profil: any) => profil.libelle_profil !== "PCL");
        return filteredData;
      })
    );
  }

  private filterEntities(libelle: string): Entite[] {
    return this.entites.filter(entity =>
      entity.libelle.toLowerCase().includes(libelle.toLowerCase())
    );
  }

  displayFn = (entite?: Entite): string => {
    return entite ? `${entite.libelle} (${this.getInterneExterneLabel(entite.interne)})` : '';
  }

  getInterneExterneLabel = (isInterne: boolean): string => {
    return isInterne ? InterneExterne.Interne : InterneExterne.Externe;
  };

  submitDialog() {
    const selectedEntiteId: number = this.profilForm.get('entite')?.value.id;
    const selectedProfilsIds = this.profilForm.get('profils')?.value;
    
    const profilsEntitesSelections: ProfilsEntitesUtilisateurBody[] = selectedProfilsIds.map((profilId: any) => ({
      users_id: 0, 
      profil_id: profilId,
      entite_id: selectedEntiteId,
    }));
    this.dialogRef.close(profilsEntitesSelections);
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
